import { computed, Injectable, signal } from '@angular/core';
import { analogeMeting, cAfdelingInfo, cAfdelingWM, cKC_Afdeling, cMetaService, ConfigProps, Losdef, sBijzPrg, Servo } from '@wasm/KopWeb';
import { JSBridgeService } from './jsbridge.service';
import { wasmVectorFindIndex, wasmVectorToArray } from '../utils/wasmVector';
import { AITypes } from '../utils/AITypes';
import { LDMenuService } from './ldmenu.service';




export type AfdMeta = {
  ais: analogeMeting[];
  servos: Servo[];
  losDefs: Losdef[];
  extraConfigs: ConfigProps[];
  afdelingInfos: cAfdelingInfo[];
  drogWands: Losdef[];
  koelings: Losdef[];
  verwarmings: Losdef[];
  bijzPrgs: sBijzPrg[];
  losDefRaw: Losdef[];
};

@Injectable({
  providedIn: null
})
export class MetaService {

  constructor(private jsBridgeService: JSBridgeService, private menuService: LDMenuService) {
  }

  private cache: Record<string, AfdMeta> = {};
  private metaService: cMetaService | undefined;

  versionChanged() {
    this.cache = {};
    this.jsBridgeService.getBridgeSync().refreshVersion();
    this.menuService.clearCache();
    this.cacheCleared.set(this.cacheCleared() + 1);
  }

  public cacheCleared = signal(0);

  public aiTypes = computed(() => {
    this.cacheCleared();
    return new AITypes(this.jsBridgeService.getBridgeSync().getAnalogeTypes());
  })

  afdelingMeta(afd: cKC_Afdeling | undefined | number) {
    if (afd != undefined) {
      let id;
      if (typeof afd == "number") {
        id = afd;
      } else {
        id = afd.type.value;
      }
      let idStr = id.toString();
      if (this.cache[idStr] != undefined) {
        return this.cache[idStr];
      }
      let jsBridge = this.jsBridgeService.getBridgeSync();
      let wasm = this.jsBridgeService.wasmModule!;
      if (this.metaService == undefined) {
        this.metaService = jsBridge.getMetaService();
      }
      let allAIsIdx = this.metaService.getAIs(id);
      let allAIS = jsBridge.getAnalogeIngagen(allAIsIdx);
      allAIsIdx.delete();

      let allServosIdx = this.metaService.getServos(id);
      let allServos = jsBridge.getServos(allServosIdx);
      allServosIdx.delete();

      let allLDIdx = this.metaService.getLosDefinitions(id);
      let allLosDefs = jsBridge.getLosDefinitions(allLDIdx);
      allLDIdx.delete();

      let extraConfigs = jsBridge.getExtraConfigs(id);
      let afdInfo = jsBridge.getAfdelingsInfo();
      let afdInfoArr = wasmVectorToArray(afdInfo);
      let cAfdInfo = afdInfoArr.find(c => c.type == id);

      let allDW: Losdef[] = [];
      let allK: Losdef[] = [];
      let allV: Losdef[] = [];
      if (cAfdInfo != undefined) {
        if (cAfdInfo.contain.get(8) == 1) {
          let allDWIdx = this.metaService.getLosDefinitions(wasm.eAfdelingType.eAT_DROOGW.value);
          let allDrogWands = jsBridge.getLosDefinitions(allDWIdx);
          allDWIdx.delete();
          allDW = wasmVectorToArray(allDrogWands).sort((a, b) => a.volgorde - b.volgorde);          
          allDrogWands.delete();
        }

        if (cAfdInfo.contain.get(7) == 1) {
          let allKoelIdx = this.metaService.getLosDefinitions(wasm.eAfdelingType.eAT_KOELING.value);
          let allKoeling = jsBridge.getLosDefinitions(allKoelIdx);
          allKoelIdx.delete();
          allK = wasmVectorToArray(allKoeling).sort((a, b) => a.volgorde - b.volgorde);
          allKoeling.delete();
        }

        if (cAfdInfo.contain.get(11) == 1) {
          let allVerwarmingIdx = this.metaService.getLosDefinitions(wasm.eAfdelingType.eAT_HEAT.value);
          let allVerwarming = jsBridge.getLosDefinitions(allVerwarmingIdx);
          allV = wasmVectorToArray(allVerwarming).sort((a, b) => a.volgorde - b.volgorde);
          allVerwarmingIdx.delete();
          allVerwarming.delete();
        } 

      }


      let allBijzPrgsIndxes = jsBridge.getBijzPrgsIndexes(id);
      let allBijzPrgs = jsBridge.getBijzPrgs(allBijzPrgsIndxes);
      let allLD = wasmVectorToArray(allLosDefs).sort((a, b) => a.volgorde - b.volgorde);


      let ret = {
        ais: wasmVectorToArray(allAIS),
        servos: wasmVectorToArray(allServos),
        losDefs: allLD,
        extraConfigs: wasmVectorToArray(extraConfigs),
        afdelingInfos: afdInfoArr,
        drogWands: allDW,
        koelings: allK,
        verwarmings: allV,
        bijzPrgs: wasmVectorToArray(allBijzPrgs).sort((a, b) => a.no - b.no),
        losDefRaw: allLD.concat(allDW).concat(allK).concat(allV)
      }
      allLosDefs.delete();
      allAIS.delete();
      allServos.delete();
      allBijzPrgs.delete();
      afdInfo.delete();

      this.cache[id] = ret;

      return ret;
    }
    return {
      ais: [],
      servos: [],
      losDefs: [],
      extraConfigs: [],
      afdelingInfos: [],
      drogWands: [],
      koelings: [],
      verwarmings: [],
      bijzPrgs: [],
      losDefRaw: []
    }
  }
}
